module.exports = __webpack_public_path__ + "static/Sahuagin-3fb88b678bd59b373318af22696fd541.jpg";